import FileSize from './FileSize';

export default FileSize;
